import { RecordScreenFormCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenFormCard";
import { CityForm } from "@/app/Cities/Cities/Forms/CityForm";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import { toFormikValidate } from "@/lib/Zod/zod-formik-adapter";
import { cityValidation } from "@/app/Cities/Cities/Validation/cityValidation";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateCityMutation } from "@/app/Cities/Cities/GraphQL/cityMutations";
import { useCityRecord } from "@/app/Cities/Cities/Hooks/useCityRecord";
import { CityDescriptionCard } from "@/app/Cities/Cities/Components/CityDescriptionCard";
import { CityHeroImageCard } from "@/app/Cities/Cities/Components/CityHeroImageCard";
import { CityMapCard } from "@/app/Cities/Cities/Components/CityMapCard";

export function CityDetailScreen() {
  const record = useCityRecord();
  const { mutateAsync } = useGqlMutation(updateCityMutation);
  const { isAdmin } = useTenant();

  return (
    <div className="space-y-6">
      <RecordScreenFormCard
        isEditable={isAdmin}
        onSubmit={async (values) => {
          return mutateAsync({
            id: record.id,
            input: values,
          });
        }}
        title="City"
        validate={toFormikValidate(cityValidation)}
        initialValues={{
          name: record.name,
          region: record.region,
          state: record.state,
          slug: record.slug,
          timezone: record.timezone,
        }}
      >
        <CityForm />
      </RecordScreenFormCard>

      {isAdmin ? (
        <>
          <CityDescriptionCard
            cityId={record.id}
            description={record.description}
          />
          <CityHeroImageCard cityId={record.id} heroImage={record.heroImage} />
          <CityMapCard cityId={record.id} lat={record.lat} lng={record.lng} />
        </>
      ) : null}
    </div>
  );
}
